import { RICHTEXT_NUMBER_TYPE } from "@visactor/vrender-core";

export class DefaultMathRichTextPicker {
    constructor(canvasRenderer) {
        this.canvasRenderer = canvasRenderer, this.type = "richtext", this.numberType = RICHTEXT_NUMBER_TYPE;
    }
    contains(richtext, point, params) {
        return !!richtext.AABBBounds.containsPoint(point);
    }
}
//# sourceMappingURL=richtext-picker.js.map
